<section class="lead-gestor" aria-label="Lead atendido pela Mia Gestor" [attr.aria-busy]="carregando">
  <div class="esqueleto" *ngIf="!dados && carregando" aria-hidden="true">
    <div class="cabeca"><span class="avatar avatar--vazio"></span><div><i class="barra barra--larga"></i><i class="barra"></i></div></div>
    <i class="bloco"></i>
  </div>

  <ng-container *ngIf="!dados && !carregando && erro">
    <p class="faixa faixa--erro" role="alert">{{ erro }}</p>
    <button type="button" class="largo" (click)="carregue()"><i class="fas fa-sync-alt" aria-hidden="true"></i>Tentar de novo</button>
  </ng-container>

  <ng-container *ngIf="dados?.gestor">
    <header class="cabeca">
      <span class="avatar" aria-hidden="true">{{ inicial }}</span>
      <div class="identidade">
        <h3>{{ dados.lead?.nome || nome || 'Lead' }}</h3>
        <span class="empresa" *ngIf="dados.lead?.empresa" title="Empresa do lead"><i class="fas fa-store" aria-hidden="true"></i>{{ dados.lead.empresa }}</span>
        <span class="num">{{ telefoneFormatado }}</span>
      </div>
      <button type="button" class="icone-botao" (click)="carregue()" [disabled]="carregando" title="Atualizar" aria-label="Atualizar">
        <i class="fas fa-sync-alt" [class.girando]="carregando" aria-hidden="true"></i>
      </button>
    </header>

    <!-- dados do lead logo abaixo do nome: ícone no lugar do rótulo (rótulo no title e para leitor de tela) -->
    <ul class="contato" *ngIf="dados.lead as lead" aria-label="Dados do lead">
      <li *ngIf="lead.instagram" title="Instagram"><i class="fab fa-instagram" aria-hidden="true"></i><span class="oculto">Instagram: </span>
        <a *ngIf="linkInstagram; else soTexto" [href]="linkInstagram" target="_blank" rel="noopener">{{ lead.instagram }}</a><ng-template #soTexto>{{ lead.instagram }}</ng-template></li>
      <li *ngIf="lead.email" title="E-mail"><i class="fas" [ngClass]="copiadoEmail ? 'fa-check' : 'fa-envelope'" aria-hidden="true"></i><span class="oculto">E-mail: </span>
        <button type="button" class="contato__copiar" (click)="copieEmail()" title="Copiar e-mail">{{ copiadoEmail ? 'Copiado' : lead.email }}</button></li>
      <li title="Canal e origem"><i class="fas fa-bullhorn" aria-hidden="true"></i><span class="oculto">Canal e origem: </span>{{ textoCanal }}</li>
      <li *ngIf="textoChegada" title="Chegada"><i class="fas fa-calendar-alt" aria-hidden="true"></i><span class="oculto">Chegada: </span>{{ textoChegada }}</li>
      <li *ngIf="lead.temComputador !== null" title="Computador"><i class="fas fa-laptop" aria-hidden="true"></i>{{ lead.temComputador ? 'Tem computador' : 'Sem computador' }}</li>
    </ul>
    <p class="canal" *ngIf="dados.numero?.modoTeste" title="Só telefones da lista de teste são atendidos">
      <i class="fas fa-flask" aria-hidden="true"></i>Número da Mia em modo teste
    </p>

    <ol class="etapas" [class.etapas--perdido]="leadPerdido" *ngIf="indiceNaRegua >= 0"
        [attr.aria-label]="'Etapa do funil: ' + (leadPerdido ? 'Perdido em ' : '') + regua[indiceNaRegua].nome">
      <li *ngFor="let e of regua; let i = index" [style.--cor]="e.cor"
          [class.feita]="i < indiceNaRegua" [class.atual]="i === indiceNaRegua">
        <span class="trilho"></span><span class="nome">{{ i === indiceNaRegua && leadPerdido ? 'Perdido' : e.nome }}</span>
      </li>
    </ol>

    <div class="agora agora--{{ agora.tom }}" role="status" *ngIf="agora as a">
      <div class="agora__linha">
        <span class="agora__icone" aria-hidden="true"><i class="fas" [ngClass]="a.icone"></i></span>
        <div>
          <strong>{{ a.titulo }}</strong>
          <p>{{ a.texto }}</p>
          <p class="agora__citacao" *ngIf="a.citacao">{{ a.citacao }}</p>
        </div>
      </div>
      <div class="agora__acao" *ngIf="principal as p">
        <button type="button" class="primario largo" (click)="executePrincipal()" [disabled]="ocupado || acompanhamento?.tom === 'andamento'">
          <i class="fas" [ngClass]="ocupado ? 'fa-spinner fa-spin' : p.icone" aria-hidden="true"></i>{{ ocupado ? 'Aguarde…' : p.rotulo }}
        </button>
        <small class="agora__explica">{{ p.explica }}</small>
      </div>
      <p class="agora__calmo" *ngIf="a.calmo && !principal"><i class="fas fa-check" aria-hidden="true"></i>{{ a.calmo }}</p>
      <p class="acompanhamento acompanhamento--{{ acompanhamento.tom }}" role="status" *ngIf="acompanhamento as acompanhamento">
        <i class="fas" [ngClass]="acompanhamento.tom === 'andamento' ? 'fa-spinner fa-spin' : acompanhamento.tom === 'ok' ? 'fa-check-circle' : 'fa-exclamation-circle'" aria-hidden="true"></i>{{ acompanhamento.texto }}
      </p>
    </div>

    <p class="faixa faixa--erro" role="alert" *ngIf="erro">{{ erro }}</p>
    <p class="faixa faixa--ok" role="status" *ngIf="aviso"><i class="fas fa-check" aria-hidden="true"></i>{{ aviso }}</p>

    <!-- modo semiautomático: a Júlia só responde quando a equipe pede, e a equipe decide se a resposta sai -->
    <section class="compor julia" *ngIf="semiAutomatico && podeEnviarPelaMia && (ultimasDoLead.length || respostaDaJulia || gerandoResposta || erroResposta)"
             aria-labelledby="julia-titulo">
      <header class="compor__topo">
        <span class="compor__icone" aria-hidden="true"><i class="fas fa-user-clock"></i></span>
        <div>
          <h4 id="julia-titulo">{{ respostaDaJulia ? 'Resposta da Júlia' : 'Lead esperando resposta' }}</h4>
          <p>{{ respostaDaJulia ? 'Nada saiu ainda. Envie se estiver boa ou descarte.' : 'Modo semiautomático: a Júlia só responde quando você pede.' }}</p>
        </div>
      </header>
      <div class="lead-disse" *ngIf="ultimasDoLead.length && !respostaDaJulia">
        <div class="lead-disse__topo">
          <span class="lead-disse__titulo"><i class="fas fa-comment" aria-hidden="true"></i>{{ ultimasDoLead.length === 1 ? '1 mensagem esperando' : ultimasDoLead.length + ' mensagens esperando' }}</span>
        </div>
        <ul class="lead-disse__lista">
          <li *ngFor="let m of ultimasDoLead"><span>{{ m.contatos?.length ? 'Contato compartilhado' : m.texto }}</span><time *ngIf="hora(m.em)">{{ hora(m.em) }}</time></li>
        </ul>
      </div>
      <div class="rascunho julia__previa" *ngIf="respostaDaJulia as r">
        <p class="julia__bolha">{{ r.texto }}</p>
        <div class="rascunho__botoes" *ngIf="r.botoes?.length || r.lista || r.link">
          <span class="rascunho__botao" *ngFor="let b of r.botoes">{{ b.titulo }}</span>
          <span class="rascunho__botao" *ngIf="r.lista"><i class="fas fa-list" aria-hidden="true"></i> {{ r.lista.rotulo || 'Ver opções' }}</span>
          <span class="rascunho__botao" *ngIf="r.link" [title]="r.link.url"><i class="fas fa-external-link-alt" aria-hidden="true"></i> {{ r.link.rotulo || 'Abrir' }}</span>
        </div>
      </div>
      <div class="rascunho__acoes">
        <button type="button" class="primario" *ngIf="respostaDaJulia" (click)="decidaRespostaDaJulia('enviar')" [disabled]="gerandoResposta || !!decidindoResposta">
          <i class="fas" [ngClass]="decidindoResposta === 'enviar' ? 'fa-spinner fa-spin' : 'fa-paper-plane'" aria-hidden="true"></i>{{ decidindoResposta === 'enviar' ? 'Enviando…' : 'Enviar' }}
        </button>
        <button type="button" [class.primario]="!respostaDaJulia" (click)="gereRespostaDaJulia()" [disabled]="gerandoResposta || !!decidindoResposta">
          <i class="fas" [ngClass]="gerandoResposta ? 'fa-spinner fa-spin' : respostaDaJulia ? 'fa-redo-alt' : 'fa-magic'" aria-hidden="true"></i>{{ gerandoResposta ? 'A Júlia está respondendo…' : respostaDaJulia ? 'Gerar de novo' : 'Gerar resposta da Júlia' }}
        </button>
        <button type="button" *ngIf="respostaDaJulia" (click)="decidaRespostaDaJulia('descartar')" [disabled]="gerandoResposta || !!decidindoResposta">
          <i class="fas" [ngClass]="decidindoResposta === 'descartar' ? 'fa-spinner fa-spin' : 'fa-times'" aria-hidden="true"></i>Descartar
        </button>
      </div>
      <small class="compor__dica" *ngIf="gerandoResposta">A Júlia está lendo a conversa. Leva até um minuto.</small>
      <small class="nota nota--erro" *ngIf="erroResposta">{{ erroResposta }}</small>
    </section>

    <!-- caixa da Mia: uma linha que abre; abre sozinha quando o lead tem mensagem sem resposta -->
    <div class="grupo grupo--solto" *ngIf="podeCompor && !comporAberto">
      <button type="button" class="linha" (click)="abraCompor()">
        <span class="linha__icone linha__icone--acento" aria-hidden="true"><i class="fas fa-pen-fancy"></i></span>
        <span class="linha__texto">
          <span class="linha__titulo">{{ podeEnviarPelaMia ? 'Pedir uma mensagem à Mia' : 'Pedir um texto à Mia' }}</span>
          <span class="linha__sub">{{ podeEnviarPelaMia ? 'Ela escreve, você revisa antes de sair.' : 'Ela escreve; você copia e manda ao lado.' }}</span>
        </span>
        <i class="fas fa-chevron-down linha__seta" aria-hidden="true"></i>
      </button>
    </div>

    <section class="compor" *ngIf="podeCompor && comporAberto" aria-labelledby="compor-titulo" [class.compor--arrastando]="arrastando"
             (dragover)="arraste($event, true)" (dragleave)="arraste($event, false)" (drop)="solteImagens($event)">
      <header class="compor__topo">
        <span class="compor__icone" aria-hidden="true"><i class="fas fa-pen-fancy"></i></span>
        <div>
          <h4 id="compor-titulo">{{ podeEnviarPelaMia ? 'Pedir uma mensagem à Mia' : 'Pedir um texto à Mia' }}</h4>
          <p>{{ podeEnviarPelaMia ? 'Diga o que você quer; ela escreve e você revisa antes de sair.' : 'Diga o que você quer; ela escreve e você copia e manda ao lado.' }}</p>
        </div>
      </header>
      <div class="lead-disse" *ngIf="ultimasDoLead.length" role="region" aria-label="Mensagens do lead sem resposta" aria-live="polite">
        <div class="lead-disse__topo">
          <span class="lead-disse__titulo"><i class="fas fa-comment" aria-hidden="true"></i>O lead disse · sem resposta</span>
          <button type="button" class="lead-disse__copiar" *ngIf="!semiAutomatico" (click)="reexecutePelaMia()" [disabled]="reexecutando || ocupado || acompanhamento?.tom === 'andamento'"
                  title="Devolve a conversa à Mia e pede que continue usando o histórico, mesmo se ela estiver pausada.">
            <i class="fas" [ngClass]="reexecutando ? 'fa-spinner fa-spin' : 'fa-redo'" aria-hidden="true"></i>{{ reexecutando ? 'Reexecutando…' : 'Reexecutar pela Mia' }}
          </button>
          <button type="button" class="lead-disse__copiar" (click)="copieMensagens()" title="Copia as mensagens abaixo, uma por linha">
            <i class="fas" [ngClass]="copiadoMensagens ? 'fa-check' : 'fa-copy'" aria-hidden="true"></i>{{ copiadoMensagens ? 'Copiado' : 'Copiar mensagens' }}
          </button>
        </div>
        <ul class="lead-disse__lista">
          <li *ngFor="let m of ultimasDoLead">
            <span *ngIf="!m.contatos?.length">{{ m.texto }}</span>
            <span *ngIf="m.contatos?.length" class="lead-disse__contatos">
              <span class="lead-disse__contato" *ngFor="let c of m.contatos">
                <i class="fas fa-address-card" aria-hidden="true"></i>
                <span><strong>{{ c.nome }}</strong>
                  <span *ngFor="let t of c.telefones">{{ t }}</span>
                  <span *ngFor="let e of c.emails">{{ e }}</span></span>
              </span>
            </span>
            <time *ngIf="hora(m.em)">{{ hora(m.em) }}</time>
          </li>
        </ul>
        <small class="nota nota--atencao" *ngIf="novasDepoisDaPrevia">
          <i class="fas fa-exclamation-circle" aria-hidden="true"></i>{{ novasDepoisDaPrevia === 1 ? 'Chegou 1 mensagem' : 'Chegaram ' + novasDepoisDaPrevia + ' mensagens' }} depois desta prévia. Monte de novo para a Mia considerar.
        </small>
      </div>
      <div class="sugestoes" role="group" aria-label="Sugestões" aria-live="polite">
        <span class="sugestoes__rotulo">{{ sugestoesDaMia ? 'Sugestões da Mia' : 'Sugestões' }}</span>
        <button type="button" class="sugestao" *ngFor="let a of atalhosDeOrientacao" (click)="useAtalho(a.texto)" [disabled]="orientando || chamando || sugerindo"
                [title]="a.texto" [class.sugestao--ativa]="orientacao === a.texto">{{ a.rotulo }}</button>
        <button type="button" class="sugestao sugestao--ia" (click)="sugiraOrientacoes()" [disabled]="sugerindo || orientando || chamando"
                title="A Mia lê a conversa e sugere caminhos para a próxima mensagem">
          <i class="fas" [ngClass]="sugerindo ? 'fa-spinner fa-spin' : 'fa-magic'" aria-hidden="true"></i>{{ sugerindo ? 'Lendo a conversa…' : sugestoesDaMia ? 'Sugerir de novo' : 'Sugerir com IA' }}
        </button>
      </div>
      <small class="nota nota--erro" *ngIf="erroSugestoes">{{ erroSugestoes }}</small>
      <div class="caixa" [class.caixa--desligada]="orientando || enviando || chamando">
        <label for="orientacao-mia" class="oculto">Como você quer a mensagem</label>
        <textarea id="orientacao-mia" rows="3" [(ngModel)]="orientacao" [disabled]="orientando || enviando || chamando" (paste)="coleImagem($event)"
                  placeholder="Como você quer a mensagem? Ex.: não abaixa o preço e oferece o teste de 7 dias de novo"></textarea>
        <ul class="anexos" *ngIf="imagens.length" aria-label="Imagens para a Mia ler">
          <li *ngFor="let img of imagens; let i = index">
            <img [src]="img" [alt]="'Imagem ' + (i + 1) + ' para a Mia ler'">
            <button type="button" class="anexos__remover" (click)="removaImagem(i)" [disabled]="orientando" [attr.aria-label]="'Remover imagem ' + (i + 1)" title="Remover">
              <i class="fas fa-times" aria-hidden="true"></i>
            </button>
          </li>
        </ul>
        <div class="caixa__barra">
          <button type="button" class="anexar" (click)="seletorDeImagem.click()" [disabled]="imagens.length >= maxImagens || orientando || enviando || chamando"
                  title="Anexe um print para a Mia ler (também dá para colar com Ctrl+V ou arrastar)">
            <i class="fas fa-image" aria-hidden="true"></i>{{ imagens.length ? imagens.length + '/' + maxImagens : 'Print para a Mia' }}
          </button>
          <input #seletorDeImagem type="file" class="oculto" accept="image/png,image/jpeg,image/webp" multiple (change)="escolhaImagens($event)" tabindex="-1" aria-hidden="true">
          <label class="modelo" title="Qual modelo monta a mensagem e as sugestões. Troque para comparar o resultado.">
            <i class="fas fa-microchip" aria-hidden="true"></i>
            <select [(ngModel)]="modelo" [disabled]="orientando || sugerindo || enviando || chamando" aria-label="Modelo que monta a mensagem">
              <option *ngFor="let m of modelos" [value]="m.id" [title]="m.dica">{{ m.rotulo }}</option>
            </select>
          </label>
          <button type="button" [class.primario]="!principal && !rascunho" [class.secundario]="!!principal || !!rascunho" (click)="monteRascunho()" [disabled]="orientando || chamando || autorizando || enviando">
            <i class="fas" [ngClass]="orientando ? 'fa-spinner fa-spin' : rascunho ? 'fa-redo-alt' : 'fa-magic'" aria-hidden="true"></i>{{ orientando ? 'Montando…' : rascunho ? 'Montar de novo' : 'Montar mensagem' }}
          </button>
        </div>
        <div class="caixa__soltar" *ngIf="arrastando" aria-hidden="true"><i class="fas fa-image"></i>Solte a imagem aqui</div>
      </div>
      <small class="nota nota--erro" *ngIf="erroOrientacao">{{ erroOrientacao }}</small>
      <small class="compor__dica" *ngIf="orientando">A Mia está lendo a conversa<ng-container *ngIf="imagens.length"> e as imagens</ng-container>. Leva até um minuto.</small>
      <small class="compor__dica" *ngIf="!rascunho && !orientando && !erroOrientacao">Pode colar ou arrastar um print: a Mia lê como contexto, o lead não vê. Imagem para o lead entra na prévia. Nada sai sem você.</small>
      <div class="rascunho" *ngIf="rascunho">
        <label for="rascunho-mia"><i class="fas fa-robot" aria-hidden="true"></i>Prévia da Mia · edite se quiser</label>
        <div class="rascunho__imagem" *ngIf="imagemParaOLead">
          <img [src]="urlDaImagemParaOLead" alt="Imagem que vai para o lead">
          <small>{{ rascunho.botoes?.length || rascunho.lista || rascunho.link ? 'Com botão, sai antes do texto, numa mensagem só dela.' : 'Vai junto com o texto, como legenda.' }}</small>
          <button type="button" class="anexos__remover" (click)="imagemParaOLead = null" [disabled]="enviando" aria-label="Tirar a imagem" title="Tirar">
            <i class="fas fa-times" aria-hidden="true"></i>
          </button>
        </div>
        <textarea id="rascunho-mia" rows="6" [(ngModel)]="rascunho.texto" [disabled]="enviando || orientando"></textarea>
        <label class="anexar" *ngIf="podeEnviarPelaMia && !imagemParaOLead" [class.anexar--desligado]="enviando || orientando || enviandoImagemParaOLead"
               title="A imagem sai pelo número da Mia junto com esta mensagem">
          <input type="file" class="oculto" accept="image/png,image/jpeg,image/webp" (change)="anexeImagemParaOLead($event)"
                 [disabled]="enviando || orientando || enviandoImagemParaOLead">
          <i class="fas" [ngClass]="enviandoImagemParaOLead ? 'fa-spinner fa-spin' : 'fa-image'" aria-hidden="true"></i>{{ enviandoImagemParaOLead ? 'Subindo…' : 'Imagem para o lead' }}
        </label>
        <div class="rascunho__botoes" *ngIf="rascunho.botoes?.length">
          <span class="rascunho__botao" *ngFor="let b of rascunho.botoes">{{ b.titulo }}</span>
        </div>
        <div class="rascunho__acoes">
          <button type="button" [class.primario]="!podeEnviarPelaMia" (click)="copieRascunho()" [disabled]="enviando || orientando || !rascunho.texto.trim()">
            <i class="fas" [ngClass]="copiado ? 'fa-check' : 'fa-copy'" aria-hidden="true"></i>{{ copiado ? 'Copiado' : 'Copiar' }}
          </button>
          <button type="button" class="primario" *ngIf="podeEnviarPelaMia" (click)="envieRascunho()" [disabled]="enviando || orientando || !rascunho.texto.trim()">
            <i class="fas" [ngClass]="enviando ? 'fa-spinner fa-spin' : 'fa-paper-plane'" aria-hidden="true"></i>{{ enviando ? 'Enviando…' : 'Enviar pela Mia' }}
          </button>
          <button type="button" (click)="descarteRascunho()" [disabled]="enviando || orientando"><i class="fas fa-times" aria-hidden="true"></i>Descartar</button>
        </div>
        <small class="nota" *ngIf="podeEnviarPelaMia">Copiar: você cola e manda pelo WhatsApp ao lado<ng-container *ngIf="imagemParaOLead"> (a imagem fica de fora)</ng-container>. Enviar pela Mia: sai como fala dela e ela continua a conversa dali.</small>
        <small class="nota" *ngIf="!podeEnviarPelaMia">A Mia não está nesta conversa: copie e mande você pelo WhatsApp ao lado.</small>
      </div>
    </section>

    <ng-container *ngIf="dados.teste as teste">
      <h4 class="secao">{{ ehCliente ? 'Loja do cliente' : 'Teste de 7 dias' }}</h4>
      <div class="grupo grupo--recheio"><app-links-teste-gestor [teste]="teste"></app-links-teste-gestor></div>
    </ng-container>

    <ng-container *ngIf="dados.lead as lead">
      <ng-container *ngIf="!ehCliente">
        <h4 class="secao">O que a Mia sabe</h4>
        <div class="grupo" *ngIf="!fichaVazia || cadastro.length; else semFicha">
          <dl *ngIf="!fichaVazia"><ng-container *ngTemplateOutlet="linhasDaFicha"></ng-container></dl>
          <p class="grupo__rotulo" *ngIf="cadastro.length">{{ fichaVazia ? 'Ainda sem conversa com a Mia. ' : '' }}Do cadastro no painel:</p>
          <dl *ngIf="cadastro.length">
            <div class="dado" *ngFor="let c of cadastro"><dt>{{ c.rotulo }}</dt><dd>{{ c.valor }}</dd></div>
          </dl>
        </div>
        <ng-template #semFicha><p class="grupo vazio">A Mia ainda não conversou com este lead.</p></ng-template>
      </ng-container>

      <ng-container *ngIf="mostraAjustes">
        <h4 class="secao">Ajustes deste lead</h4>
        <div class="grupo">
          <div class="ajuste">
            <app-oferta-lead-gestor [oferta]="ofertaDoLead" [urlSalvar]="'/gestor-ia/lead-contato/' + digitos + '/oferta'"
                                    [urlSugerir]="'/gestor-ia/lead-contato/' + digitos + '/sugerir-oferta'" [podeSugerir]="!!dados.atendimento"
                                    (salvo)="ofertaSalva($event)"></app-oferta-lead-gestor>
          </div>
          <div class="linha" *ngIf="followup as f">
            <span class="linha__icone" aria-hidden="true"><i class="fas" [ngClass]="mudandoFollowup ? 'fa-spinner fa-spin' : 'fa-redo-alt'"></i></span>
            <span class="linha__texto">
              <span class="linha__titulo">{{ f.ligadoNoNumero && !f.ligado ? 'Follow-up desligado' : 'Follow-up automático' }}</span>
              <span class="linha__sub">{{ textoFollowup }}</span>
            </span>
            <label class="chave" [title]="f.ligadoNoNumero ? (f.ligado ? 'Desligar para este lead' : 'Ligar para este lead') : 'Desligado no número'">
              <input type="checkbox" [checked]="f.ligado && f.ligadoNoNumero" [disabled]="!f.ligadoNoNumero || mudandoFollowup"
                     (change)="mudeFollowup(!f.ligado)" aria-label="Follow-up automático para este lead"><span></span>
            </label>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="temMaisAcoes">
      <h4 class="secao">Mais ações</h4>
      <div class="grupo">
        <button type="button" class="linha linha--perigo linha--destaque" *ngIf="podeMarcarPerdido && perdaSugerida" (click)="abraPerda()" [disabled]="movendo || anotandoPerda">
          <span class="linha__icone" aria-hidden="true"><i class="fas fa-times"></i></span>
          <span class="linha__texto"><span class="linha__titulo">Marcar como perdido</span>
            <span class="linha__sub">{{ pediuParar ? 'Com o motivo "pediu para parar" já preenchido.' : 'A Mia para de responder e cancela os toques.' }}</span></span>
          <i class="fas fa-chevron-right linha__seta" aria-hidden="true"></i>
        </button>
        <button type="button" class="linha" *ngIf="acaoChamar && principal?.tipo !== 'chamar'" (click)="chameMia()" [disabled]="ocupado || acompanhamento?.tom === 'andamento'">
          <span class="linha__icone linha__icone--acento" aria-hidden="true"><i class="fas" [ngClass]="chamando ? 'fa-spinner fa-spin' : acaoChamar.icone"></i></span>
          <span class="linha__texto"><span class="linha__titulo">{{ acaoChamar.rotulo }}</span>
            <span class="linha__sub">{{ acaoChamar.explica }}</span></span>
          <i class="fas fa-chevron-right linha__seta" aria-hidden="true"></i>
        </button>
        <button type="button" class="linha" *ngIf="podeIniciarTeste" (click)="inicieTeste()" [disabled]="ocupado || orientando">
          <span class="linha__icone" aria-hidden="true"><i class="fas" [ngClass]="iniciandoTeste ? 'fa-spinner fa-spin' : 'fa-store'"></i></span>
          <span class="linha__texto"><span class="linha__titulo">Iniciar criação da loja</span>
            <span class="linha__sub">Pula a qualificação; a Mia pede só o que falta para o teste de 7 dias.</span></span>
          <i class="fas fa-chevron-right linha__seta" aria-hidden="true"></i>
        </button>
        <button type="button" class="linha" *ngIf="podeAutorizar" (click)="autorize()" [disabled]="ocupado">
          <span class="linha__icone" aria-hidden="true"><i class="fas" [ngClass]="autorizando ? 'fa-spinner fa-spin' : 'fa-user-check'"></i></span>
          <span class="linha__texto"><span class="linha__titulo">Só autorizar</span>
            <span class="linha__sub">Não manda nada agora; a Mia responde a próxima mensagem.</span></span>
          <i class="fas fa-chevron-right linha__seta" aria-hidden="true"></i>
        </button>
        <button type="button" class="linha" *ngIf="dados.lead && !ehCliente && !leadPerdido && !pediuParar" (click)="mova('CLIENTE')" [disabled]="movendo">
          <span class="linha__icone" aria-hidden="true"><i class="fas fa-trophy"></i></span>
          <span class="linha__texto"><span class="linha__titulo">Mover para Cliente</span>
            <span class="linha__sub">Quando assinar. A Mia para de vender e de mandar toques.</span></span>
          <i class="fas fa-chevron-right linha__seta" aria-hidden="true"></i>
        </button>
        <button type="button" class="linha" *ngIf="ehCliente" (click)="mova(dados.lead.etapaMinima || 'CONVERSA')" [disabled]="movendo">
          <span class="linha__icone" aria-hidden="true"><i class="fas fa-undo-alt"></i></span>
          <span class="linha__texto"><span class="linha__titulo">Voltar para {{ rotuloEtapa(dados.lead.etapaMinima || 'CONVERSA') }}</span>
            <span class="linha__sub">Se marcou Cliente por engano.</span></span>
          <i class="fas fa-chevron-right linha__seta" aria-hidden="true"></i>
        </button>
        <button type="button" class="linha linha--perigo" *ngIf="podeMarcarPerdido && !perdaSugerida" (click)="abraPerda()" [disabled]="movendo || anotandoPerda">
          <span class="linha__icone" aria-hidden="true"><i class="fas fa-times"></i></span>
          <span class="linha__texto"><span class="linha__titulo">Marcar como perdido</span>
            <span class="linha__sub">{{ ehCliente ? 'Cancelou a assinatura.' : 'A Mia para de responder e cancela os toques.' }}</span></span>
          <i class="fas fa-chevron-right linha__seta" aria-hidden="true"></i>
        </button>
        <button type="button" class="linha" *ngIf="leadPerdido && !anotandoPerda" (click)="abraPerda()" [disabled]="movendo">
          <span class="linha__icone" aria-hidden="true"><i class="fas fa-pen"></i></span>
          <span class="linha__texto"><span class="linha__titulo">{{ dados.lead.motivoPerda ? 'Editar motivo' : 'Anotar motivo' }}</span>
            <span class="linha__sub">Alimenta o relatório de leads.</span></span>
          <i class="fas fa-chevron-right linha__seta" aria-hidden="true"></i>
        </button>
        <button type="button" class="linha linha--perigo" *ngIf="podeMudarBloqueio && !bloqueada" (click)="mudeBloqueio(true)" [disabled]="mudandoBloqueio || ocupado">
          <span class="linha__icone" aria-hidden="true"><i class="fas" [ngClass]="mudandoBloqueio ? 'fa-spinner fa-spin' : 'fa-ban'"></i></span>
          <span class="linha__texto"><span class="linha__titulo">Não quer mais contato</span>
            <span class="linha__sub">Fica registrado no lead e nada mais sai para este número: nem resposta da Mia, nem toque, nem reativação.</span></span>
          <i class="fas fa-chevron-right linha__seta" aria-hidden="true"></i>
        </button>
        <button type="button" class="linha" *ngIf="podeMudarBloqueio && bloqueada" (click)="mudeBloqueio(false)" [disabled]="mudandoBloqueio || ocupado">
          <span class="linha__icone" aria-hidden="true"><i class="fas" [ngClass]="mudandoBloqueio ? 'fa-spinner fa-spin' : 'fa-undo-alt'"></i></span>
          <span class="linha__texto"><span class="linha__titulo">Desfazer "não quer mais contato"</span>
            <span class="linha__sub">Só se ele mesmo pediu para voltar. A conversa fica com você até chamar a Mia.</span></span>
          <i class="fas fa-chevron-right linha__seta" aria-hidden="true"></i>
        </button>
        <a class="linha" *ngIf="dados.situacao === 'fora_lista'" href="/admin/mia-gestor/numeros" target="_blank" rel="noopener">
          <span class="linha__icone" aria-hidden="true"><i class="fas fa-cog"></i></span>
          <span class="linha__texto"><span class="linha__titulo">Abrir a tela de números</span>
            <span class="linha__sub">Para incluir este telefone na lista ou tirar o número do modo teste.</span></span>
          <i class="fas fa-external-link-alt linha__seta" aria-hidden="true"></i>
        </a>

        <form class="perda" *ngIf="anotandoPerda" (ngSubmit)="confirmePerda()">
          <label for="motivo-perda">{{ leadPerdido ? 'Motivo da perda' : 'Por que perdemos este lead?' }}</label>
          <textarea id="motivo-perda" name="motivoPerda" rows="3" maxlength="300" [(ngModel)]="motivoPerda" autofocus
                    placeholder="Ex.: achou caro, já usa outro sistema, parou de responder…"></textarea>
          <small class="perda__sugestao" *ngIf="motivoSugerido"><i class="fas fa-robot" aria-hidden="true"></i>Sugerido pela objeção que a Mia registrou na ficha. Edite se for outro.</small>
          <div class="perda__botoes">
            <button type="submit" class="perigo" [disabled]="movendo"><i class="fas" [ngClass]="movendo ? 'fa-spinner fa-spin' : 'fa-times'" aria-hidden="true"></i>{{ leadPerdido ? 'Salvar motivo' : 'Marcar como perdido' }}</button>
            <button type="button" (click)="cancelePerda()" [disabled]="movendo">Cancelar</button>
          </div>
        </form>
      </div>
    </ng-container>

    <details class="grupo grupo--solto" *ngIf="ehCliente && !fichaVazia">
      <summary class="linha">
        <span class="linha__icone" aria-hidden="true"><i class="fas fa-history"></i></span>
        <span class="linha__texto"><span class="linha__titulo">Ficha da venda</span><span class="linha__sub">O que a Mia registrou antes de ele assinar</span></span>
        <i class="fas fa-chevron-right linha__seta" aria-hidden="true"></i>
      </summary>
      <dl><ng-container *ngTemplateOutlet="linhasDaFicha"></ng-container></dl>
    </details>

    <p class="rodape-painel" *ngIf="dados.lead">
      <a [href]="linkKanban" target="_blank" rel="noopener">Ver no kanban <i class="fas fa-external-link-alt" aria-hidden="true"></i></a>
    </p>

    <ng-template #linhasDaFicha>
      <ng-container *ngIf="ficha as f">
        <div class="dado" *ngIf="f.segmento"><dt>Segmento</dt><dd>{{ f.segmento }}</dd></div>
        <div class="dado" *ngIf="f.ferramentaAtual"><dt>Usa hoje</dt><dd>{{ f.ferramentaAtual }}</dd></div>
        <div class="dado" *ngIf="f.problema"><dt>Problema</dt><dd>{{ f.problema }}</dd></div>
        <div class="dado" *ngIf="f.objecao"><dt>Objeção</dt><dd>{{ f.objecao }}</dd></div>
        <div class="dado" *ngIf="f.proximoPasso"><dt>Próximo passo</dt><dd>{{ f.proximoPasso }}</dd></div>
      </ng-container>
    </ng-template>
  </ng-container>
</section>
